const LOG_PREFIX = '[GET - Search Results]'

const constants = {
  LOG_PREFIX,
}

export default constants;